import Navigation from "./lib/navigation";
import stickyContent from "./lib/stickyContent";
import Accordion from "./lib/accordion";
import Splide from "@splidejs/splide";
import SmoothScroll from "smooth-scroll";

/* -------------------------------------------------------------------
  utility
------------------------------------------------------------------- */
const smoothScroll = new SmoothScroll('a[href*="#"]', {
  speed: 500,
  speedAsDuration: true,
  popstate: true,
  updateURL: true,
  header: ".js-header",
  offset: () => {
    const wpbar = document.querySelector("#wpadminbar");
    return wpbar ? wpbar.offsetHeight : 0; // 管理バーがあるときだけ加算
  },
});

(function () {
  const header = document.querySelector(".js-header");
  const wpbar = document.querySelector("#wpadminbar");

  const setOffsetVar = () => {
    const headerH = header ? header.offsetHeight : 0;
    const wpbarH = wpbar ? wpbar.offsetHeight : 0;
    document.documentElement.style.setProperty(
      "--fixed-offset",
      `${headerH + wpbarH}px`
    );
  };

  // 初期化＆リサイズ時に更新（フォント/画像で高さが変わるケースにも対応）
  window.addEventListener("load", setOffsetVar);
  window.addEventListener("resize", setOffsetVar);
  setOffsetVar();
})();

Navigation("header-nav__btn", "body");

stickyContent("footer", "header");

const spAccordion = new Accordion(".js-sp-accordion", {
  speed: 400,
  target: "next",
  event: "click",
  breakpoint: 768,
  breakpointType: "max",
  disableLink: true,
});

const sdgsAnswer = new Accordion(".js-sdgs-answer", {
  speed: 400,
  target: "prev",
  event: "click",
});

const faq = new Accordion(".js-faq", {
  speed: 400,
  target: "next",
  event: "click",
  display: "flex",
});

document.addEventListener("DOMContentLoaded", () => {
  const homeFvSplideOptions = {
    type: "fade",
    arrows: false,
    pagination: false,
    rewind: true,
    autoplay: true,
    interval: 5000,
    drag: false,
    pauseOnHover: false,
  };
  const homeFvListClass = ".js-home-fv";
  const homeFvList = document.querySelector(homeFvListClass);
  if (!homeFvList) return;
  const homeFvSplide = new Splide(homeFvListClass, homeFvSplideOptions);
  homeFvSplide.mount();
});

document.addEventListener("DOMContentLoaded", () => {
  const caseSplideOptions = {
    type: "slide",
    arrows: false,
    pagination: false,
    gap: "40px",
    fixedWidth: 350,
    breakpoints: {},
  };
  const caseListClass = ".js-case-list";
  const caseList = document.querySelector(caseListClass);
  if (!caseList) return;
  const caseListType = caseList.dataset.type;

  if (caseListType === "aside") {
    caseSplideOptions.fixedWidth = 343;
    caseSplideOptions.breakpoints[768] = {
      fixedWidth: 343,
    };
  }

  const caseSplide = new Splide(caseListClass, caseSplideOptions);

  caseSplide.mount();
  const prev = document.querySelector(".js-case-arrow-prev");
  const next = document.querySelector(".js-case-arrow-next");

  prev.addEventListener("click", () => caseSplide.go("<"));
  next.addEventListener("click", () => caseSplide.go(">"));

  // 非loop時の無効化表示（任意）
  const update = () => {
    const Controller = caseSplide.Components.Controller;
    prev.disabled = caseSplide.index <= 0;
    next.disabled = caseSplide.index >= Controller.getEnd();
  };
  caseSplide.on("mounted move updated", update);
});
